export default "__VITE_ASSET__BWqmedYM__"